import React from 'react';
import PropTypes from 'prop-types';
import { Box, Drawer, Typography } from '@mui/material';
import {
    contentSx,
    footerSx,
    grabHandleSx,
    grabHandleWrapSx,
    headerSx,
    sheetPaperSx,
    titleSx
} from './MobileBottomSheet.styles';

// A sheet sliding up from the bottom of a phone: within reach of the thumb,
// where a popover would open at the far end of the screen. Holds the grid's
// filters and sorting, a row's actions and the page menu; the caller supplies
// the content. `footer` sits below the scrolling content and stays in view.
export default function MobileBottomSheet({
    open,
    onClose,
    title,
    headerRight,
    footer,
    children
}) {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: [
                    sheetPaperSx,
                    // A footer clears the home indicator itself; without one
                    // the paper has to.
                    !footer && { pb: 'env(safe-area-inset-bottom)' }
                ]
            }}
        >
            <Box sx={grabHandleWrapSx}>
                <Box sx={grabHandleSx} />
            </Box>
            {(title || headerRight) && (
                <Box sx={headerSx}>
                    <Typography component="div" sx={titleSx}>
                        {title}
                    </Typography>
                    {headerRight}
                </Box>
            )}
            <Box sx={contentSx}>{children}</Box>
            {footer && <Box sx={footerSx}>{footer}</Box>}
        </Drawer>
    );
}

MobileBottomSheet.propTypes = {
    children: PropTypes.node,
    footer: PropTypes.node,
    headerRight: PropTypes.node,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    title: PropTypes.node
};
